// Application configuration
const dev_mode = false;

const config = {
  // API Base URL
  API_BASE_URL: dev_mode ? 'http://localhost:5001/api' : '/api',
  
  // Analytics
  GOOGLE_ANALYTICS_ID: 'G-4YQWSN6VGB', // GA4 Measurement ID
  GOOGLE_TAG_MANAGER_ID: 'GTM-NTCZ4S2F', // GTM Container ID
  
  // Weekly Reports API endpoints
  WEEKLY_REPORTS_BASE: '/weekly-reports',
  
  // Polling intervals (milliseconds)
  POLLING_INTERVALS: {
    ALERTS: 30000,      // 30 seconds for real-time alerts
    DASHBOARD: 60000,   // 1 minute for dashboard data
    CHARTS: 120000,     // 2 minutes for chart data
  },
  
  // Pagination defaults
  PAGINATION: {
    DEFAULT_PAGE_SIZE: 25,
    MAX_PAGE_SIZE: 100,
    PAGE_SIZE_OPTIONS: [10, 25, 50, 100],
  },
  
  // Risk levels and their colors
  RISK_LEVELS: {
    CRITICAL: { color: '#dc2626', label: 'Critical', priority: 4 },
    HIGH: { color: '#ea580c', label: 'High', priority: 3 },
    MEDIUM: { color: '#d97706', label: 'Medium', priority: 2 },
    LOW: { color: '#16a34a', label: 'Low', priority: 1 },
    UNKNOWN: { color: '#6b7280', label: 'Unknown', priority: 0 }
  },
  
  // Alert levels
  ALERT_LEVELS: {
    RED: { color: '#dc2626', label: 'Immediate Action Required' },
    ORANGE: { color: '#ea580c', label: 'Enhanced Surveillance' },
    YELLOW: { color: '#d97706', label: 'Increased Monitoring' },
    GREEN: { color: '#16a34a', label: 'Routine Surveillance' }
  },
  
  // Chart colors
  CHART_COLORS: [
    '#3b82f6', '#ef4444', '#f59e0b', '#10b981', 
    '#8b5cf6', '#f97316', '#06b6d4', '#84cc16',
    '#ec4899', '#6366f1', '#14b8a6', '#f472b6'
  ],
  
  // Export formats
  EXPORT_FORMATS: ['json', 'csv', 'ndjson'],
  
  // Date formats
  DATE_FORMATS: {
    DISPLAY: 'MMM dd, yyyy',
    ISO: 'yyyy-MM-dd',
    DATETIME: 'MMM dd, yyyy HH:mm',
    TIME: 'HH:mm'
  },
  
  // Table limits
  TABLE_LIMITS: {
    MAX_VISIBLE_ROWS: 1000,
    VIRTUAL_SCROLL_THRESHOLD: 100
  },
  
  // Geographic regions for filtering
  REGIONS: [
    'North America', 'South America', 'Europe', 'Asia', 
    'Africa', 'Oceania', 'Antarctica'
  ],
  
  // Common hosts for filtering
  HOSTS: [
    'human', 'dairy_cow', 'chicken', 'turkey', 'duck', 'goose',
    'swan', 'wild_bird', 'pig', 'cat', 'dog', 'other_avian',
    'other_mammal'
  ],
  
  // Mutation categories
  MUTATION_CATEGORIES: [
    'receptor_binding', 'polymerase', 'neuraminidase', 
    'glycosylation', 'cleavage_site', 'other'
  ],
  
  // Feature flags
  FEATURES: {
    REAL_TIME_ALERTS: true,
    ADVANCED_ANALYTICS: true,
    EXPORT_FUNCTIONALITY: true,
    MAP_VISUALIZATION: true,
    SSE_ALERTS: true
  },
  
  // Default time ranges
  TIME_RANGES: [
    { label: 'Last 24 hours', value: 1, unit: 'days' },
    { label: 'Last 7 days', value: 7, unit: 'days' },
    { label: 'Last 30 days', value: 30, unit: 'days' },
    { label: 'Last 90 days', value: 90, unit: 'days' },
    { label: 'Last 6 months', value: 6, unit: 'months' },
    { label: 'Last year', value: 1, unit: 'years' },
  ],
  
  // Batch selection limits
  BATCH_LIMITS: {
    MAX_COMPARISON_BATCHES: 5,
    DEFAULT_BATCH_HISTORY: 30
  }
};

export default config;